import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Main } from './layout/main/main';
import { Login } from './pages/auth/login/login';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
const routes: Routes = [
  //  Auth routes
  {
    path: 'login',
    component: Login,
    title: 'Login'
  },
  {
    path: '',
    component: Login,
    title: 'Login'
  },
  {
    path: 'reset-password/:id/:validity',
    component: ResetPasswordComponent,
    title: 'Reset Password'
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Forgot Password'
    }
  },
  //  Main layout routes (moved to 'app')
  {
    path: '',
    component: Main,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./layout/main/main.module').then((m) => m.MainModule)
      }
    ]
  },

  //  Wildcard route
  {
    path: '**',
    loadChildren: () =>
      import('./pages/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      )
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }